import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

// Shown on every "request raised" confirmation in the QRC flows. The CRM takes a couple of
// minutes to publish a new ticket, so a customer who opens the ticket list straight after
// submitting sees nothing there and assumes the request was lost. Kept in one component so the
// wording and the wait it quotes stay identical across all of those confirmations.
const TicketReflectionNotice = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-start",
      gap: 1.25,
      // The dialogs around this are centre-aligned; a two-line paragraph reads better left-aligned.
      textAlign: "left",
      px: 2,
      py: 1.5,
      mb: 3,
      borderRadius: 2,
      // Same cream + amber as the escalation banner on the ticket cards, so warnings look alike.
      borderLeft: "4px solid #EAB308",
      bgcolor: "#FCF6E3",
    }}
  >
    <InfoOutlinedIcon sx={{ color: "#EAB308", fontSize: 20, flexShrink: 0, mt: "2px" }} />
    <Typography sx={{ fontSize: "0.875rem", color: "#3A3A3A", lineHeight: 1.6 }}>
      <Box component="span" sx={{ fontWeight: 700 }}>
        Please note:
      </Box>{" "}
      Your ticket may take{" "}
      <Box component="span" sx={{ fontWeight: 700 }}>
        2-3 minutes
      </Box>{" "}
      to reflect in the portal. If you don't see it right away, please refresh the page after a
      short while.
    </Typography>
  </Box>
);

export default TicketReflectionNotice;
